var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#35BAEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03 5l6.274 5.565c.073.067.152.123.213.195a.7.7 0 01.009.129c-.003 2.397.006 4.792-.003 7.186a2.876 2.876 0 00-.89.345L9.09 12.878a.163.163 0 01-.059-.146c.006-2.578 0-5.154.006-7.73L9.03 5zm7.447 8.607a6.97 6.97 0 014.112 1.698c-.327.35-.68.68-1.018 1.023-.714.712-1.423 1.43-2.14 2.135a2.707 2.707 0 00-.952-.388c-.008-1.487 0-2.977 0-4.468h-.002zm-7.444.668c1.628 1.613 3.246 3.237 4.871 4.853-.19.295-.326.62-.402.963H9.03v-5.819l.003.003zm11.606 2.333c.213-.204.408-.423.633-.62a6.942 6.942 0 011.7 4.1c-1.467.006-2.937 0-4.404.003-.088.02-.088-.082-.105-.137a2.497 2.497 0 00-.359-.811c.84-.846 1.689-1.689 2.535-2.532v-.003zM9.03 21.042h3.821c.219 0 .438-.01.66.005.068.338.2.66.387.948l-3.1 3.092c-.023.018-.061.073-.088.03a6.918 6.918 0 01-1.68-4.075zm9.462.005c.63-.014 1.254 0 1.884-.005h2.596a6.883 6.883 0 01-1.657 4.045l-1.808-1.802c-.452-.455-.913-.902-1.36-1.363.167-.268.284-.565.345-.875zm-1.254 1.73c.07-.04.14-.082.21-.117l3.156 3.15a6.936 6.936 0 01-4.127 1.707v-4.463a2.61 2.61 0 00.758-.28l.003.003zm-4.591 1.794c.642-.636 1.277-1.28 1.925-1.91.29.186.613.32.95.393v4.463a6.936 6.936 0 01-4.112-1.698c.403-.423.826-.828 1.237-1.245v-.003z",
    fill: "#FFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBts);
export default __webpack_public_path__ + "static/media/bts.6bd6d41589018d22fac9ac7b5aa1a07c.svg";
export { ForwardRef as ReactComponent };